import { createPageApp } from '@/lib/createPageApp'
import MainPage from './MainPage.vue'

createPageApp(MainPage).mount()
